// اضافه کردن کتابخانه ها به صفحه
import * as React from 'react';
import NavBar from "../../components/NavBar";
import SimpleMap from "../../components/SimpleMap";
import {Autocomplete, Box, CircularProgress, TextField} from "@mui/material";
import {Add} from "@mui/icons-material";
import {useTranslation} from "react-i18next";
import {useSnackbar} from "notistack";
import {useLocation} from "react-router-dom";
import {useDispatch, useSelector} from "react-redux";
import {setLoading} from "../../redux/loading/actions";
import {handleBorderColor, handleScrollIntoView, HandleValidationMethod, removeNonNumeric, useShowMessageComponent} from "../../assets/js/main";
import HandleFetchData from "../../plugin/HandleFetchData";
import {setValidations} from "../../redux/public/actions";


export default function Address(props) {
  // استفاده از متود های i18n برای چند زبان کردن پروژه و تغییر زبان پروژه
  const {t} = useTranslation()
  const location = useLocation()
  const {enqueueSnackbar} = useSnackbar();
  const dispatch = useDispatch();
  const selector = useSelector((st) => st)
  const {fetchData} = HandleFetchData()
  const {validationMethod} = HandleValidationMethod()

  const firstNameRef = React.useRef()
  const lastNameRef = React.useRef()
  const phoneRef = React.useRef()
  const addressRef = React.useRef()

  // متغیر و useState های لوکال صفحه
  const [firstName, setFirstName] = React.useState('');
  const [lastName, setLastName] = React.useState('');
  const [phoneNumber, setPhoneNumber] = React.useState('');
  const [email, setEmail] = React.useState('');
  const [state_id, setState_Id] = React.useState();
  const [company, setCompany] = React.useState('');
  const [lng, setLng] = React.useState(51.4);
  const [lat, setLat] = React.useState(35.7);
  const [addressFromMap, setAddressFromMap] = React.useState('');
  const [listStateAndCity, setListStateAndCity] = React.useState([])
  const [stateAndCity, setStateAndCity] = React.useState(null)
  const [textStateAndCity, setTextStateAndCity] = React.useState('')

  const [city_id, setCity_Id] = React.useState();


  React.useEffect(() => {
    // getState(state)
    handleGetStateAndCity()
    window.history.replaceState(null, '')
  }, [])


  // متد دریافت لیست استان ها
  const handleGetStateAndCity = async (e) => {
    dispatch(setLoading(true))
    let fetch = await fetchData('nbl', 'GET', `/v1/Address/getStateCity`, '', "application/json", {
      "term": e
    }, 'postex')
    setListStateAndCity(fetch?.data)
    dispatch(setLoading(false))

  }

  const splitState_City = (e) => {
    setLng(e?.lon)
    setLat(e?.lat)
    setState_Id(e.id.split('-')[0]);
    setCity_Id(e.id.split('-')[1]);
  }

  const validations = () => {
    !firstName ?
       validationMethod(firstNameRef, 'firstName_validation', t("error.t4"))
       :
       !lastName ?
          validationMethod(lastNameRef, 'lastName_validation', t("error.t5"))
          :
          !phoneNumber ?
             validationMethod(phoneRef, 'phoneNumber_validation', t("error.t6"))
             :
             (phoneNumber.length !== 11 || !phoneNumber.startsWith("09")) ?
                validationMethod(phoneRef, 'phoneNumber_validation', t("error.t7"))
                :
                !addressFromMap ?
                   validationMethod(addressRef, 'address_validation', t("error.t8"))
                   :
                   addAddress()
  }

  const addAddress = async () => {
    dispatch(setLoading(true))
    dispatch(setValidations(null))
    let fetch = await fetchData('', 'POST', '/AddAddress', {
         "firstName": firstName,
         "lastName": lastName,
         "email": email,
         "company": company,
         "countryId": state_id,
         "stateProvinceId": city_id,
         "city": "",
         "address1": addressFromMap,
         "address2": "",
         "zipPostalCode": "",
         "phoneNumber": phoneNumber
       },
       "application/json", '', '',''
    )

    enqueueSnackbar(fetch?.Message, {
      variant: fetch?.IsSuccess ? 'success' : 'error',
      TransitionProps: {
        direction: 'down',
      },
      anchorOrigin: {
        horizontal: 'center',
        vertical: 'top'
      }
    });

    dispatch(setLoading(false))
  }

  return (
     <>
       {/*کامپوننت نوبار*/}
       <div className="d-block d-lg-none">
         <NavBar blue back/>
       </div>

       <div className="addressPage desktopSection">
         <div className="container">

           {/*Desktop Page*/}
           <div className="row">
             <div className="col-12">
               <h4 className="titleSection">{location?.state ? t("dashboard.address.t26") : t("dashboard.address.t2")}</h4>
             </div>

             <div className="col-12 col-md-6">
               <label>{t("dashboard.address.t4")}</label>
               <input type="text" name="firstName" ref={firstNameRef}
                      style={handleBorderColor(selector?.public?.validations?.firstName_validation)}
                      value={firstName} id="firstName"
                      onChange={e => setFirstName(e.target.value)}/>
               {
                 selector?.public?.validations?.firstName_validation &&
                 <p className="error">{selector?.public?.validations?.firstName_validation}</p>
               }
             </div>
             <div className="col-12 col-md-6">
               <label>{t("dashboard.address.t5")}</label>
               <input type="text" name="lastName" ref={lastNameRef}
                      style={handleBorderColor(selector?.public?.validations?.lastName_validation)}
                      value={lastName} id="lastName"
                      onChange={e => setLastName(e.target.value)}/>
               {
                 selector?.public?.validations?.lastName_validation &&
                 <p className="error">{selector?.public?.validations?.lastName_validation}</p>
               }
             </div>
             <div className="col-12 col-md-6">
               <label>{t("dashboard.address.t6")}</label>
               <input type="text" name="phone" id="phone" ref={phoneRef}
                      style={handleBorderColor(selector?.public?.validations?.phoneNumber_validation)}
                      value={phoneNumber} className="numeric"
                      onChange={e => e.target.value.length <= 11 && setPhoneNumber(removeNonNumeric(e.target.value))}/>
               {
                 selector?.public?.validations?.phoneNumber_validation &&
                 <p className="error">{selector?.public?.validations?.phoneNumber_validation}</p>
               }
             </div>
             <div className="col-12 col-md-6">
               <label>{t("dashboard.address.t7")}</label>
               <input type="text" name="company" id="company"
                      onChange={e => setCompany(e.target.value)}/>
             </div>

             <div className="col-12 col-lg-6">
               <label>{t("dashboard.address.t18")}</label>
               <Autocomplete
                  inputValue={textStateAndCity}
                  noOptionsText={t("autoComplete.t1")}
                  id="previous-address-sender-3"
                  disablePortal
                  autoHighlight
                  loading={selector?.loading?.isLoading}
                  onChange={(e, value, reason) => {
                    if (reason === 'clear') {
                      setTextStateAndCity('')
                      setStateAndCity(null)
                    } else {
                      setTextStateAndCity(value?.name)
                      setStateAndCity(value);
                      splitState_City(value)
                    }
                  }}
                  options={listStateAndCity || []}
                  getOptionLabel={(option) => option?.name}
                  renderInput={(params) =>
                     <TextField {...params}
                                hiddenLabel
                                size="small"
                                placeholder={t("singleOrder.sender.t19")}
                                onChange={(event) => {
                                  setTextStateAndCity(event?.target?.value)
                                  event?.target?.value?.length > 2 && handleGetStateAndCity(event?.target?.value)
                                }}
                                InputProps={{
                                  ...params.InputProps,
                                  endAdornment: (
                                     <React.Fragment>
                                       {selector?.loading?.isLoading ? <CircularProgress style={{margin: '0 5px'}} size={20}/> : null}
                                       {params.InputProps.endAdornment}
                                     </React.Fragment>
                                  ),
                                }}
                     />}
               />
             </div>

             <div className="col-12">
               <label>{t("dashboard.address.t10")}</label>
               <textarea rows="4" placeholder={t("dashboard.address.t11")}
                         style={handleBorderColor(selector?.public?.validations?.address_validation)}
                         value={addressFromMap} id="addressFromMap" ref={addressRef}
                         onChange={e => setAddressFromMap(e.target.value)}/>
               {
                 selector?.public?.validations?.address_validation &&
                 <p className="error">{selector?.public?.validations?.address_validation}</p>
               }
             </div>

             <div className="col-12">
               <SimpleMap
                  handlerLngFromMap={(event) => setLng(event)}
                  handlerLatFromMap={(event) => setLat(event)}
                  handlerAddressFromMap={(event) => setAddressFromMap(event?.address)}
                  coordinates={[
                    {
                      "pointX": lat,
                      "pointY": lng
                    }
                  ]}
                  searchInMap={textStateAndCity}
                  showSearchInMap={false}
               />
             </div>


             <div className="_btnGroup_yellow ">
               <button className="btnFill" onClick={() => validations()} disabled={selector?.loading?.isLoading} id="validations">
                 {
                   selector?.loading?.isLoading ?
                      <Box sx={{display: 'flex'}}>
                        <CircularProgress size={20}/>
                      </Box>
                      :
                      <>
                        <span>{t("dashboard.address.t12")}</span>
                        <Add fontSize="large"/>
                      </>
                 }

               </button>
             </div>
           </div>
         </div>
       </div>
     </>
  )
}
